var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0305 16.9697H12.5153L18.3761 80.5233L43.7693 87.7253L69.1626 80.5233L75.0305 16.9697Z",
    fill: "#E6A329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7694 22.1476V82.3397L64.3438 76.5105L69.3492 22.1476H43.7694Z",
    fill: "#F1BF22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1373 29.9445H28.5031L26.2996 53.7397L26.3453 53.5918H53.2205L52.344 63.659L43.7693 66.1265L35.0679 63.6203L34.5469 57.5272H26.648L27.7744 69.7029L43.7693 74.2437L59.7712 69.7029L61.9748 45.8056H33.4522L33.8183 37.8433H53.6077L53.9034 42.4053H61.8727L60.1373 29.9445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7764 29.9445H28.5031L26.2996 53.7397L26.3453 53.5918H43.7764V45.8302H34.5645L34.9306 37.868H43.7764V29.9445ZM34.5645 57.5272H26.648L27.7744 69.6958L43.7693 74.2296V66.1336L35.0679 63.6203L34.5645 57.5272Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6904 7.596H32.1252V11.5912H41.6715V-0.274719H37.6904V7.596ZM55.4171 -0.211359H45.716V3.94224C47.0113 5.2376 47.6872 5.86064 49.595 7.7368H45.716V11.5243H55.4171V7.74384L51.538 3.94928H55.4171V-0.211359Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.7ffe6dea6b1deee673cb55f2b3ee8248.svg";
export { ForwardRef as ReactComponent };